import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap'
import { connect } from 'react-redux'
import _ from 'lodash'

class CarouselComponent extends Component {

    onClick(type, id) {
        if (type == 'non-keyword') {
        }
        else {
            type == 'keyword' ? this.props.history.push(`/search/${id}`) : this.props.history.push(`/product/${id}`)
        }
    }

    renderCarousels() {
        let id = 1
        return _.map(this.props.carouselstate.carousels, carousel => {
            return (
                <Carousel.Item style={{ cursor: 'pointer' }} key={id++} onClick={() => { this.onClick(carousel.type, carousel.id) }}>
                    <img width={'100%'} height={'auto'} alt={carousel.id} src={carousel.img_url} />
                </Carousel.Item>
            )
        })
    }

    render() {
        return (
            <Carousel>
                {this.renderCarousels()}
            </Carousel>
        )
    }
}

function mapStateToProps(state) {
    return {
        carouselstate: state.carouselstate
    }
}

export default connect(mapStateToProps)(CarouselComponent)


// WEBPACK FOOTER //
// ./src/components/carousel.js